const slideImgs = [
  {
    image: "/images/slide-1.jpg",
    title: "Cultural",
    span: "Experiences",
    detail:
      "Culturally ebullient but not well discovered, every unforgettable undertaking you do in Ethiopia could be labeled as a cultural experience.",
  },
  {
    image: "/images/slide-2.jpg",
    title: "Nature",
    span: "Experiences",
    detail:
      "with its diverse ecological systems laden with a plethora of wildlife Ethiopia is a haven for nature travelers",
  },
  {
    image: "/images/slide-3.jpg",
    title: "Outdoor",
    span: "and adventure",
    detail:
      "Outdoor and adventure are the eliciting factors that whet the appetite of all travelers to Ethiopia.",
  },
  {
    image: "/images/slide-4.jpg",
    title: "Educational",
    span: "Tour",
    detail:
      "Immerse yourself in the rich paleontological sites, vibrant way of life, and opulent geological resources of Ethiopia.",
  },
  {
    image: "/images/slide-5.jpg",
    title: "Trekking",
    span: "on peaks",
    detail:
      "The majestic highlands of Ethiopia offer some exceptional trekking experiences. The Simien Mountains and Bale Mountains are common favorites.",
  },
]

export default slideImgs
